"use client";

import React from "react";
import { ArrowRight, Clock, Phone, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function Dispatch() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="emergencydispatchcta" data-nav="light" className="relative bg-background py-16 text-foreground md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl border border-border bg-muted/40 p-8 shadow-lg md:p-14">
          {/* Subtle background decoration */}
          <div aria-hidden="true" className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-primary/5 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-accent/10 blur-3xl" />

          <div className="relative z-10 mx-auto max-w-3xl text-center">
            <div className="mb-4 flex flex-wrap items-center justify-center gap-2">
              <Badge variant="secondary" className="px-3 py-1 font-medium">
                <Clock className="size-3.5" />
                24/7 Live Emergency Dispatch
              </Badge>
              <Badge variant="outline" className="px-3 py-1 font-medium">
                <ShieldCheck className="size-3.5" />
                Direct Local Crews
              </Badge>
            </div>

            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
              Emergency property damage? We respond in minutes.
            </h2>

            <p className="font-default mt-4 text-base text-muted-foreground sm:text-lg">
              Speak directly with our on-call restoration team in Maryland, DC,
              and Northern Virginia. No call centers, no runaround, and direct
              insurance coordination from day one.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-12 w-full px-7 text-base font-semibold shadow-md transition-[color,background-color,border-color,box-shadow] sm:w-auto">
                <a href="tel:8554356631" className="inline-flex items-center gap-2">
                  <Phone className="size-4 shrink-0" />
                  <span>Call 855-435-6631</span>
                </a>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-12 w-full border-border px-7 text-base font-semibold transition-[color,background-color,border-color,box-shadow] sm:w-auto">
                <Link to="/ContactRequestServicePage" className="inline-flex items-center gap-2">
                  <span>Request Service</span>
                  <ArrowRight className="size-4 shrink-0" />
                </Link>
              </Button>
            </div>

            <p className="mt-4 text-xs text-muted-foreground">
              Direct dispatch for water extraction, fire cleanup, mold remediation, and storm repairs.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}